import React from "react";
import * as SurveyReact from "survey-react-ui";
import Select from "react-select";

class ChipSelect extends SurveyReact.SurveyQuestionCheckbox {
  // Convert the `visibleChoices` array to a format supported by React Select
  get options() {
    return this.question.visibleChoices.map((c) => {
      const value = String(c.value);
      return {
        value,
        label: c.text || value
      };
    });
  }

  // Retrieve an option object based on the question value
  get selectedOption() {
    const opts = this.options;
    let qValue: string[] = this.question.value;
    if (!qValue) qValue = [];
    return opts.filter((o) => qValue.includes(o.value));
  }

  // Set the question value to the selected option value
  onSelectChange = (selectedOption: readonly { value: string }[] | null) => {
    if (!selectedOption?.length) {
      this.question.value = [];
      return;
    }
    this.question.value = selectedOption.map((o) => o.value);
  };

  renderElement() {
    // If the question is non-editable, render a stylized div
    if (this.isDisplayMode) {
      return (
        <div
          id={this.question.inputId}
          className={this.question.getControlClass()}
          aria-disabled="true"
        >
          {" "}
          {this.question.displayValue || this.question.placeholder}{" "}
        </div>
      );
    }
    return (
      <Select
        id={this.question.inputId}
        value={this.selectedOption}
        onChange={this.onSelectChange}
        options={this.options}
        isMulti={true}
        required={this.question.isRequired}
        menuPortalTarget={document.querySelector("body")}
      />
    );
  }
}

export default ChipSelect;
